export default __webpack_public_path__ + "static/ProValue_2-9bb453ea99d93844390c163d4f461a81.png";